import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {Provider as $71dfb0e0358a12de$export$2881499e37b75b9a, useProvider as $71dfb0e0358a12de$export$693cdb10cec23617, useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686, useSlotProps as $62024859ff9f1f8a$export$1e5c9e6e4e15efe3} from "../utils/Slots.mjs";
import "../buttongroup_vars.css";
import $bhDJM$buttongroup_vars_cssmjs from "../buttongroup_vars_css.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {filterDOMProps as $bhDJM$filterDOMProps} from "react-aria/filterDOMProps";
import $bhDJM$react, {useCallback as $bhDJM$useCallback, useRef as $bhDJM$useRef} from "react";
import {useLayoutEffect as $bhDJM$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useResizeObserver as $bhDJM$useResizeObserver} from "react-aria/private/utils/useResizeObserver";
import {useValueEffect as $bhDJM$useValueEffect} from "react-aria/private/utils/useValueEffect";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 










const $3a97ced4c1581335$export$69b1032f2ecdf404 = /*#__PURE__*/ (0, $bhDJM$react).forwardRef(function ButtonGroup(props, ref) {
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $62024859ff9f1f8a$export$1e5c9e6e4e15efe3)(props, 'buttonGroup');
    let { children: children, orientation: orientation = 'horizontal', isDisabled: isDisabled, align: align = 'start', ...otherProps } = props;
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let [hasOverflow, setHasOverflow] = (0, $bhDJM$useValueEffect)(false);
    let checkForOverflow = (0, $bhDJM$useCallback)(()=>{
        let computeHasOverflow = ()=>{
            if (domRef.current && orientation === 'horizontal') {
                let buttonGroupChildren = Array.from(domRef.current.children);
                let maxX = domRef.current.offsetWidth + 1; // + 1 to account for rounding errors
                // If any buttons have negative X positions (align="end") or extend beyond
                // the width of the button group (align="start"), then switch to vertical.
                if (buttonGroupChildren.some((child)=>child.offsetLeft < 0 || child.offsetLeft + child.offsetWidth > maxX)) return true;
                return false;
            }
        };
        if (orientation === 'horizontal') setHasOverflow(function*() {
            // Force to horizontal for measurement.
            yield false;
            // Measure, and update if there is overflow.
            yield computeHasOverflow();
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef,
        orientation,
        scale,
        setHasOverflow,
        children
    ]);
    // There are two main reasons we need to remeasure:
    // 1. Internal changes: Check for initial overflow or when orientation/scale/children change (from checkForOverflow dep array)
    (0, $bhDJM$useLayoutEffect)(()=>{
        checkForOverflow();
    }, [
        checkForOverflow
    ]);
    // 2. External changes: buttongroup won't change size due to any parents changing size, so listen to its container for size changes to figure out if we should remeasure
    let parent = (0, $bhDJM$useRef)(undefined);
    (0, $bhDJM$useLayoutEffect)(()=>{
        if (domRef.current) parent.current = domRef.current.parentElement;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef.current
    ]);
    (0, $bhDJM$useResizeObserver)({
        ref: parent,
        onResize: checkForOverflow
    });
    return /*#__PURE__*/ (0, $bhDJM$react).createElement("div", {
        ...(0, $bhDJM$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($bhDJM$buttongroup_vars_cssmjs))), 'spectrum-ButtonGroup', {
            'spectrum-ButtonGroup--vertical': orientation === 'vertical' || hasOverflow,
            'spectrum-ButtonGroup--alignEnd': align === 'end',
            'spectrum-ButtonGroup--alignCenter': align === 'center'
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $bhDJM$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            button: {
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($bhDJM$buttongroup_vars_cssmjs))), 'spectrum-ButtonGroup-Button')
            }
        }
    }, /*#__PURE__*/ (0, $bhDJM$react).createElement((0, $71dfb0e0358a12de$export$2881499e37b75b9a), {
        isDisabled: isDisabled
    }, children)));
});


export {$3a97ced4c1581335$export$69b1032f2ecdf404 as ButtonGroup};
//# sourceMappingURL=ButtonGroup.mjs.map
